import { Container } from "reactstrap"
import styled from "styled-components"
import { Card, CustomButton } from "../../components"
import { COLORS } from "../../constants"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { levelcolors } from "../../constants"
import { useState, useEffect } from "react"

import { useHistory } from "react-router-dom"
import axios from "axios"

const StyledCardContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
`;
const StyledGridCardWrapper = styled.div`
    padding: 5px;
    height: 250px;
`;
const StyledCard = styled(Card)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    transition: box-shadow 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);

`;
const StyledCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.bgColor};
    width: 80px;
    height: 80px;
    border-radius: 50%;
    color:  ${props => props.color};;
`;
const staticLevelData = [
    {
        level_no: 1,
        games: []
    },
    {
        level_no: 2,
        games: []
    },
    {
        level_no: 3,
        games: []
    },
    {
        level_no: 4,
        games: []
    },
    {
        level_no: 5,
        games: []
    },
    {
        level_no: 6,
        games: []
    }
]
function MyLevelsScreen() {
    const history = useHistory();
    const user = useSelector(state => state.auth.user.user)
    const [data, setData] = useState([]);
    const api = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);
    const [noData, setNoData] = useState(false);

    const fixArray = (data) => {
        let parentLevels = [];

        for (var i = 0; i < 6; i++) {

            if (!data.find(element => element.level_no == i + 1)) {
                parentLevels[i] = staticLevelData[i];

            } else {
                parentLevels[i] = data.find(element => element.level_no == i + 1);
            }
        }
        return parentLevels;
    }
    useEffect(async () => {
        try {
            const response = await axios.get(`${api}/ps/puchased_games/${user.email}`);
            const data = response.data.levels;
            console.log(data)

            if (data) {
                setData(fixArray(data))

            } else if (response.data == 0) {
                setNoData(true)
            }
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }, [])
    if (loading) {
        return <h6 className="text-center color-text-green">Loading...</h6>
    }
    if (noData) {
        return <h6 className="text-center color-text-green">Currently there is no purchased games in your account</h6>
    } else {
        return (
            <StyledCardContainer>
                {data.map((entry, i) => {
                    return <StyledGridCardWrapper className="grid-card" key={i}>
                        <StyledCard>
                            <StyledCircle bgColor={levelcolors[i].bgColor} color={levelcolors[i].color}>
                                <h1 className="mb-0">{entry.level_no}</h1>
                            </StyledCircle>
                            <h4 className="mt-2">Level {entry.level_no}</h4>
                            {entry.games.length > 0 ? <div className="mb-1"><span className="color-text-grey">{entry.games.length}</span>/50 Games</div> : <div className="mb-1"><span className="color-text-grey">Not Purchased</span></div>}

                            {entry.games.length > 35 ? null :
                                <CustomButton
                                    bgColor={COLORS.green}
                                    hover={COLORS.text_green}
                                    color={COLORS.text_dark_green}
                                    onClick={() => history.push('/store')}
                                    style={{ padding: "0 15px", height: 45, fontSize: 15 }}
                                >
                                    Buy Games
                            </CustomButton>
                            }

                        </StyledCard>
                    </StyledGridCardWrapper>
                })}



            </StyledCardContainer>
        );
    }
}

export default MyLevelsScreen;